import React, { useCallback, useEffect, useReducer } from 'react';
import { TextField, Typography } from "@material-ui/core";
import Autocomplete from '@material-ui/lab/Autocomplete';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import imgClose from '../../../assets/ic_close.png';
import { format } from 'date-fns';

function ListReservationFilter(props) {
    const defaultParamQuery = {
        doctor_id: [],
        polyclinic_id: [],
        session_schedule: [],
        session_schedule_detail: [],
        payment_option: [],
        reservation_from: [],
        status: [],
        patient_name: "",
        queue_number: "",
        booking_id: "",
        patient_mobile_phone: "",
        patient_phone: "",
        start: null,
        end: null,
    }

    const [task, updateTask] = useReducer(
        (prev, next) => ({
            ...prev,
            ...next,
        }),
        {
            ...defaultParamQuery,
        }
    );

    const onChangeCombo = (value, name) => {
        updateTask({
            [name]: value,
        });
    };

    const listPayment = [
        { id: 1, value: 'Umum' },
        { id: 2, value: 'Asuransi/Jaminan' },
        { id: 3, value: 'BPJS' },
    ]

    const listStatus = [
        { id: 1, value: 'Book' },
        { id: 2, value: 'Reschedule' },
        { id: 3, value: 'Check-In' },
        { id: 4, value: 'Cancel' },
        { id: 5, value: 'Done' },
        { id: 6, value: 'Hold' },
    ]

    const listReservasi = [
        { id: 0, value: 'Sistem Lainnya' },
        { id: 1, value: 'Mobile' },
        { id: 2, value: 'Web Admin' },
        { id: 3, value: 'Kiosk' },
        { id: 4, value: 'Mobile JKN' },
    ]

    const setDefaultData = useCallback(
        () => {
            const _paramQuery = props?.dataParamQuery
            if (_paramQuery) {
                updateTask({
                    ..._paramQuery
                })
            }
        },
        [props?.dataParamQuery],
    )

    useEffect(() => {
        setDefaultData()
    }, [setDefaultData])

    const getParamQuery = () => {
        const isNullOrEmpty = (val) => {
            const bool = val === null || val === ""
            return bool
        }
        let doctor_id = []
        let polyclinic_id = []
        let status = []
        let payment_option = []
        let session_schedule = []
        let reservation_from = []
        let session_schedule_detail = []

        task?.doctor_id?.length > 0 && task?.doctor_id.forEach((item) => {
            doctor_id.push(item.id)
        })
        task?.polyclinic_id?.length > 0 && task?.polyclinic_id.forEach((item) => {
            polyclinic_id.push(item.id)
        })
        task?.status?.length > 0 && task?.status.forEach((item) => {
            status.push(item.id)
        })
        task?.payment_option?.length > 0 && task?.payment_option.forEach((item) => {
            payment_option.push(item.id)
        })
        task?.session_schedule?.length > 0 && task?.session_schedule.forEach((item) => {
            session_schedule.push(item.time)
        })
        task?.reservation_from?.length > 0 && task?.reservation_from.forEach((item) => {
            reservation_from.push(item.id)
        })
        task?.session_schedule_detail?.length > 0 && task?.session_schedule_detail.forEach((item) => {
            session_schedule_detail.push(item.time)
        })
        const filteredData = (_obj) => {
            const result = Object.entries(_obj)
                .filter(([key, value]) => value !== "" && value !== undefined && value !== null && value.toString() !== '')
                .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
            return result
        }
        let paramQuery = null
        let _tmp = {
            ...task,
            doctor_id,
            polyclinic_id,
            session_schedule,
            session_schedule_detail,
            reservation_from,
            payment_option,
            status,
        }

        if (isNullOrEmpty(task?.start) && isNullOrEmpty(task?.end)) {
            const _filterParam = filteredData(_tmp)
            paramQuery = `${Object.keys(_filterParam).length === 0 ? "" : `&filter=${JSON.stringify(_filterParam)}`}`
        } else {
            const _startDate = format(new Date(task?.start), 'yyyy-MM-dd').toString()
            const _endDate = format(new Date(task?.end), 'yyyy-MM-dd').toString()
            delete _tmp?.start
            delete _tmp?.end
            const _filterParam = filteredData(_tmp)
            paramQuery = `&date_filter={"appointment_date": {"start": "${_startDate}", "end": "${_endDate}"}}${Object.keys(_filterParam).length === 0 ? "" : `&filter=${JSON.stringify(_filterParam)}`}`
        }
        props.onFind(paramQuery, task)
    }

    return (
        <>
            <div className="App app-popup-show" style={{ zIndex: 1250 }}>
                <div className="popup-content background-white" style={{ borderRadius: 30, margin: 'auto', overflow: 'auto', width: 1000 }}>
                    <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 30, borderTopLeftRadius: 30, backgroundColor: '#f5f5f5' }}>
                        <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                            <div className="popup-title">
                                <span style={{ color: 'black', fontSize: 18, }}>Filter</span>
                            </div>
                        </div>
                        <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                            <button
                                type="button"
                                className="btn btn-circle btn-white"
                                onClick={() => props.onClose()}
                            >
                                <img src={imgClose} style={{ width: 20, height: 20 }} alt='img-close' />
                            </button>
                        </div>
                    </div>

                    <form
                        onSubmit={(e) => {
                            e.preventDefault()
                            // handleSearch()
                        }}>
                        <div style={{ maxHeight: 700, overflow: 'scroll', backgroundColor: '#fff', marginTop: 25 }}>
                            <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: '0px', width: '90%', margin: 'auto' }}>
                                <div className="column-1" style={{ margin: 'auto' }}>
                                    <TextField
                                        style={{ width: '100%' }}
                                        label="ID Reservasi"
                                        placeholder={"Input ID Reservasi"}
                                        value={task?.booking_id}
                                        onChange={(e) => {
                                            onChangeCombo(e.target.value, 'booking_id')
                                        }}
                                        inputProps={{
                                            style: {
                                                fontSize: 14,
                                            }
                                        }}
                                        InputLabelProps={{
                                            style: {
                                                fontSize: 16,
                                                color: '#7e8085',
                                            }
                                        }}
                                    />
                                </div>
                                <div className="column-2" style={{ marginTop: 5 }}>
                                    <Autocomplete
                                        multiple
                                        options={props.dataDokter}
                                        getOptionLabel={(option) => option?.name || ""}
                                        getOptionSelected={(option, value) => option.id === value.id}
                                        debug
                                        size='small'
                                        onChange={(event, newInputValue) => {
                                            onChangeCombo(newInputValue, 'doctor_id')
                                        }}
                                        value={task?.doctor_id}
                                        renderInput={(params) =>
                                            <TextField
                                                {...params}
                                                InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                                InputLabelProps={{ style: { color: '#7e8085' } }}
                                                label="Nama Dokter"
                                            />
                                        }
                                    />
                                </div>
                            </div>

                            <div style={{ marginTop: 15 }}>
                                <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: '0px', width: '90%', margin: 'auto' }}>
                                    <div className="column-1" style={{ margin: 'auto' }}>
                                        <Autocomplete
                                            multiple
                                            options={props.dataPoli}
                                            getOptionLabel={(option) => option?.name || ""}
                                            getOptionSelected={(option, value) => option.id === value.id}
                                            size="small"
                                            onChange={(event, newInputValue) => {
                                                onChangeCombo(newInputValue, 'polyclinic_id')
                                            }}
                                            value={task?.polyclinic_id}
                                            renderInput={(params) =>
                                                <TextField
                                                    {...params}
                                                    InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                                    InputLabelProps={{ style: { color: '#7e8085' } }}
                                                    label="Klinik"
                                                />
                                            }
                                        />
                                    </div>
                                    <div className="column-2" >
                                        <TextField
                                            style={{ width: '100%' }}
                                            label="Nama Pasien"
                                            placeholder={"Input Nama Pasien"}
                                            value={task?.patient_name}
                                            onChange={(e) => {
                                                onChangeCombo(e.target.value, 'patient_name')
                                            }}
                                            inputProps={{
                                                style: {
                                                    fontSize: 14,
                                                }
                                            }}
                                            InputLabelProps={{
                                                style: {
                                                    fontSize: 16,
                                                    color: '#7e8085',
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div style={{ marginTop: 15 }}>
                                <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: '0px', width: '90%', margin: 'auto' }}>
                                    <div className="column-1" style={{ margin: 'auto' }}>
                                        <TextField
                                            style={{ width: '100%' }}
                                            label="No HP Pasien"
                                            placeholder={"Input No HP Pasien"}
                                            value={task?.patient_mobile_phone}
                                            onChange={(e) => {
                                                onChangeCombo(e.target.value, 'patient_mobile_phone')
                                            }}
                                            inputProps={{
                                                style: {
                                                    fontSize: 14,
                                                }
                                            }}
                                            InputLabelProps={{
                                                style: {
                                                    fontSize: 16,
                                                    color: '#7e8085',
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className="column-2" >
                                        <TextField
                                            style={{ width: '100%' }}
                                            label="No Telepon Pasien"
                                            placeholder={"Input No Telepon Pasien"}
                                            value={task?.patient_phone}
                                            onChange={(e) => {
                                                onChangeCombo(e.target.value, 'patient_phone')
                                            }}
                                            inputProps={{
                                                style: {
                                                    fontSize: 14,
                                                }
                                            }}
                                            InputLabelProps={{
                                                style: {
                                                    fontSize: 16,
                                                    color: '#7e8085',
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div style={{ marginTop: 15 }}>
                                <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: '0px', width: '90%', margin: 'auto' }}>
                                    <div className="column-1" style={{ margin: 'auto' }}>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardDatePicker
                                                margin="normal"
                                                clearable
                                                label="Tgl. Reservasi Awal"
                                                format="dd/MM/yyyy"
                                                placeholder="dd/MM/yyyy"
                                                defaultValue="Tgl. Reservasi Awal"
                                                value={task?.start}
                                                autoFill={false}
                                                autoComplete="off"
                                                minDate={new Date()}
                                                onChange={(date) => {
                                                    updateTask({
                                                        start: date,
                                                        end: date
                                                    })
                                                }}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                inputProps={{
                                                    style: {
                                                        fontSize: 14,
                                                    }
                                                }}
                                                InputLabelProps={{
                                                    style: {
                                                        fontSize: 16,
                                                        color: '#7e8085',
                                                    }
                                                }}
                                                style={{ width: '100%', cursor: 'pointer', marginTop: 0 }}
                                            />

                                        </MuiPickersUtilsProvider>
                                    </div>
                                    <div className="column-2">
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardDatePicker
                                                margin="normal"
                                                clearable
                                                label="Tgl. Reservasi Akhir"
                                                format="dd/MM/yyyy"
                                                placeholder="dd/MM/yyyy"
                                                // defaultValue="Tgl. Reservasi Akhir"
                                                value={task?.end}
                                                autoFill={false}
                                                autoComplete="off"
                                                minDate={new Date(task?.start)}
                                                onChange={(date) => {
                                                    onChangeCombo(date, 'end')
                                                }}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                inputProps={{
                                                    style: {
                                                        fontSize: 14,
                                                    }
                                                }}
                                                InputLabelProps={{
                                                    style: {
                                                        fontSize: 16,
                                                        color: '#7e8085',
                                                    }
                                                }}
                                                style={{ width: '100%', cursor: 'pointer', marginTop: 0 }}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </div>
                                </div>
                            </div>

                            <div style={{ marginTop: 2 }}>
                                <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: '0px', width: '90%', margin: 'auto' }}>
                                    <div className="column-1" style={{ margin: 'auto' }}>
                                        <TextField
                                            style={{ width: '100%' }}
                                            label="No Antrian"
                                            placeholder={"Input No Antrian"}
                                            value={task?.queue_number}
                                            onChange={(e) => {
                                                onChangeCombo(e.target.value, 'queue_number')
                                                // forceUpdate()
                                            }}
                                            inputProps={{
                                                style: {
                                                    fontSize: 14,
                                                }
                                            }}
                                            InputLabelProps={{
                                                style: {
                                                    fontSize: 16,
                                                    color: '#7e8085',
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className="column-2" style={{ margin: 2 }}>
                                        <Autocomplete
                                            multiple
                                            options={listPayment}
                                            getOptionLabel={(option) => option?.value}
                                            getOptionSelected={(option, value) => option.id === value.id}
                                            debug
                                            onChange={(event, newInputValue) => {
                                                onChangeCombo(newInputValue, 'payment_option')
                                            }}
                                            value={task?.payment_option}
                                            renderInput={(params) =>
                                                <TextField
                                                    {...params}
                                                    InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                                    InputLabelProps={{ style: { color: '#7e8085' } }}
                                                    label="Opsi Pembayaran"
                                                />
                                            }
                                        />
                                    </div>
                                </div>
                            </div>

                            <div style={{ marginTop: 0 }}>
                                <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: '0px', width: '90%', margin: 'auto' }}>
                                    <div className="column-1" style={{ margin: 'auto' }}>
                                        {/* <Autocomplete
                                            multiple
                                            options={listStatus}
                                            getOptionLabel={(option) => option?.value}
                                            debug
                                            onChange={(event, newInputValue) => {
                                                // setPickStatusFilter(newInputValue)
                                                // forceUpdate()
                                            }}
                                            renderInput={(params) =>
                                                <TextField
                                                    {...params}
                                                    InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                                    InputLabelProps={{ style: { color: '#7e8085' } }}
                                                    label="Jadwal Periksa"
                                                />
                                            }
                                        /> */}
                                    </div>
                                    <div className="column-2" >
                                        {/* <Autocomplete
                                            multiple
                                            options={listStatus}
                                            getOptionLabel={(option) => option?.value}
                                            debug
                                            onChange={(event, newInputValue) => {
                                                // setPickStatusFilter(newInputValue)
                                                // forceUpdate()
                                            }}
                                            renderInput={(params) =>
                                                <TextField
                                                    {...params}
                                                    InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                                    InputLabelProps={{ style: { color: '#7e8085' } }}
                                                    label="Opsi Pembayaran"
                                                />
                                            }
                                        /> */}
                                    </div>
                                </div>
                            </div>

                            <div style={{ marginTop: 15 }}>
                                <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: '0px', width: '90%', margin: 'auto' }}>
                                    <div className="column-1" style={{ margin: 'auto' }}>
                                        <Autocomplete
                                            multiple
                                            options={listReservasi}
                                            getOptionLabel={(option) => option?.value}
                                            getOptionSelected={(option, value) => option.id === value.id}
                                            size="small"
                                            onChange={(event, newInputValue) => {
                                                onChangeCombo(newInputValue, 'reservation_from')
                                            }}
                                            value={task?.reservation_from}
                                            renderInput={(params) =>
                                                <TextField
                                                    {...params}
                                                    InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                                    InputLabelProps={{ style: { color: '#7e8085' } }}
                                                    label="Reservasi Via"
                                                />
                                            }
                                        />
                                    </div>
                                    <div className="column-2" >
                                        <Autocomplete
                                            multiple
                                            options={listStatus}
                                            getOptionLabel={(option) => option?.value}
                                            getOptionSelected={(option, value) => option.id === value.id}
                                            size="small"
                                            onChange={(event, newInputValue) => {
                                                onChangeCombo(newInputValue, 'status')
                                            }}
                                            value={task?.status}
                                            renderInput={(params) =>
                                                <TextField
                                                    {...params}
                                                    InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                                    InputLabelProps={{ style: { color: '#7e8085' } }}
                                                    label="Status"
                                                />
                                            }
                                        />
                                    </div>
                                </div>
                            </div>

                            <div style={{ marginTop: 15 }}>
                                <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: '0px', width: '90%', margin: 'auto' }}>
                                    <div className="column-1" style={{ margin: 'auto' }}>
                                        <Autocomplete
                                            multiple
                                            options={props.dataSession}
                                            getOptionLabel={(option) => option?.time || ""}
                                            getOptionSelected={(option, value) => option.time === value.time}
                                            debug
                                            size='small'
                                            onChange={(event, newInputValue) => {
                                                onChangeCombo(newInputValue, 'session_schedule')
                                            }}
                                            value={task?.session_schedule}
                                            renderInput={(params) =>
                                                <TextField
                                                    {...params}
                                                    InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                                    InputLabelProps={{ style: { color: '#7e8085' } }}
                                                    label="Sesi Jadwal"
                                                />
                                            }
                                        />
                                    </div>
                                    <div className="column-2" >
                                        <Autocomplete
                                            multiple
                                            options={props.dataSchedule}
                                            getOptionLabel={(option) => option?.time || ""}
                                            getOptionSelected={(option, value) => option.time === value.time}
                                            debug
                                            size='small'
                                            onChange={(event, newInputValue) => {
                                                onChangeCombo(newInputValue, 'session_schedule_detail')
                                            }}
                                            value={task?.session_schedule_detail}
                                            renderInput={(params) =>
                                                <TextField
                                                    {...params}
                                                    InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                                    InputLabelProps={{ style: { color: '#7e8085' } }}
                                                    label="Jadwal Periksa"
                                                />
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                            {/* {visibleMessageError && (
                                <div style={{ marginTop: 20 }}>
                                    <Typography style={{ color: 'red', fontSize: 11, }}>{messageError}</Typography>
                                </div>
                            )} */}
                            <div className="" style={{ display: 'flex', justifyContent: 'flex-end', marginRight: 35, marginBottom: 15 }}>
                                <button
                                    onClick={() => {
                                        updateTask({
                                            ...defaultParamQuery
                                        })
                                    }}
                                    style={{ backgroundColor: 'transparent', height: '4vh', borderRadius: '4vh', alignItems: 'center', display: 'grid', cursor: 'pointer', outline: 'none', borderColor: 'transparent', marginTop: 20, marginRight: 15, padding: '0px 20px' }}>
                                    <Typography style={{ color: '#2A9C6C', fontSize: 15, textAlign: 'center' }}>Reset</Typography>
                                </button>
                                <button
                                    onClick={() => getParamQuery()}
                                    style={{ backgroundColor: '#2A9C6C', height: '4vh', width: 150, borderRadius: '4vh', alignItems: 'center', display: 'grid', cursor: 'pointer', outline: 'none', borderColor: 'transparent', marginTop: 20, padding: '0px 20px', boxShadow: '5px 2px 10px 0 #999999', }}>
                                    <Typography style={{ color: '#fff', fontSize: 15, textAlign: 'center' }}>Filter</Typography>
                                </button>
                                {/* <div onClick={() => {
                                }} style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                    <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Reset</Typography>
                                </div>
                                <div onClick={(e) => {}} style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                    <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Filter</Typography>
                                </div> */}
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}


export default ListReservationFilter